import { gql } from '@apollo/client';

const UNPUBLISH_COURSE_MUTATION = gql`
    mutation unpublishCourse( $courseID: UUID! ) {
        result: unpublishCourse( courseID: $courseID ) {
            success
        }
    }
`;

export default UNPUBLISH_COURSE_MUTATION;
